import { Container, Row, Col, Card } from "react-bootstrap";
import '../scss/pages/FrequentlyAskedQuestions.scss';
import PageTitle from "../components/shared/PageTitle";
import DocumentOne from "../assets/pdfs/Stellest Patient IFU V6.pdf";
import DocumentTwo from "../assets/pdfs/Stellest Practitioner IFU V6.pdf";

const FrequentlyAskedQuestions = () => {
    return (
        <>
            <Container fluid className="mt-20">
                <PageTitle title="FAQs and Resources" />
                <Row>
                    <Col sm={12}>
                        <Card className="shadow-sm rounded-3 p-4">
                            {/*<Card.Header>*/}
                            {/*    <h2 className="text-xl font-semibold">FAQs</h2>*/}
                            {/*</Card.Header>*/}
                            <Card.Body>
                                <Row className="mb-10">
                                    <Col>
                                        <div className="grid gap-4 md:grid-cols-2">
                                            <a
                                                href={DocumentOne}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="p-4 bg-light rounded-2xl shadow hover:shadow-md transition-all no-underline d-block"
                                            >
                                                <h3 className="text-lg mb-2">Stellest Patient IFU V6</h3>
                                                <p>Click to view the PDF resource.</p>
                                            </a>

                                            <a
                                                href={DocumentTwo}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="p-4 bg-light rounded-2xl shadow hover:shadow-md transition-all no-underline d-block"
                                            >
                                                <h3 className="text-lg mb-2">Stellest Practitioner IFU V6</h3>
                                                <p>Click to view the PDF resource.</p>
                                            </a>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default FrequentlyAskedQuestions;
